import { IAnnotation, ICondition } from '@ahryman40k/ts-fhir-types/lib/R4';
import { Component, OnInit } from '@angular/core';
import { AlertDecourseDetailsComponent } from '../../../shared/abstracts/alert-decourse-details/alert-decourse-details.component';
import { TranslatePipe } from '../../../shared/translate/pipes/translate.pipe';

@Component({
  selector: 'inc-decourse-details',
  templateUrl: './decourse-details.component.html',
  styleUrls: ['./decourse-details.component.scss'],
})
export class DecourseDetailsComponent extends AlertDecourseDetailsComponent<ICondition> implements OnInit {

  constructor(private translatePipe: TranslatePipe) { super(); }

  ngOnInit() { super.ngOnInit(); }

  onCallSaveComment(comment: IAnnotation): void {
    this.inData.note.push(comment);
    this.callCommentSaveAndUpdate.emit(this.inData);
  }

  onCallUpdateComment(comment: IAnnotation): void {
    this.inData.note[this.commentUpdateId] = comment;
    this.callCommentSaveAndUpdate.emit(this.inData);
  }

  onCallCancelComment(): void { this.callCancelComment.emit(); }

  onCallCommentMore(comment: IAnnotation): void {
    this.callCommentMore.emit({
      component: this.inData,
      index: this.inData.note.indexOf(comment)
    });
  }

  checkForPermission(): boolean {
    if (this.user && this.user.uid && this.inData && this.inData.recorder && this.inData.recorder.reference) {
      return this.user.uid === this.inData.recorder.reference;
    }
  }

  getTitle(): string {
    if (this.inData && this.inData.note && this.inData.note.length > 0) {
      if (this.inData.note[0].text.includes('_MEASUREMENT')) {
        const splitted = this.inData.note[0].text.split('_');
        if (splitted.length === 3 && splitted[splitted.length - 1] === 'MEASUREMENT') {
          return (this.translatePipe.transform('MEASUREMENT_FIRST') + ' ' + splitted[0] + ' ' +
            this.translatePipe.transform(splitted[1] + '_MEASUREMENT') + ' ' + this.translatePipe.transform('MEASUREMENT_SECOND'))
            .trim();
        }
      } else {
        return this.translatePipe.transform(this.inData.note[0].text);
      }
    }
  }

  getNote(index: number): any {
    if (this.inData && this.inData.note && this.inData.note.length > 0) {
      if (index < 0) { return this.inData.note.slice(1); }
      return this.inData.note[index];
    }
  }

  getNotesLength(): number { return this.inData.note.length - 1; }
}
